import { useRef, useEffect } from 'react'

export default (effect, inputs = []) => {
  const isInitialMount = useRef(true)

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      effect()
    }
  }, inputs)
}
